import { Badge } from '@/components/ui/Badge';
import { Card, CardContent, CardHeader } from '@/components/ui/Card';
import { useHealth } from '@/hooks/useDispatcher';
import { useAuthStore } from '@/stores/authStore';

type PingLike = { ok: boolean; error?: string } | string | null | undefined;

export default function AccountPage() {
  const user = useAuthStore((s) => s.user);
  const health = useHealth();
  const healthData = health.data;

  return (
    <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
      <Card>
        <CardHeader title="Profil" />
        <CardContent className="space-y-2 text-sm">
          <Field label="Email" value={user?.email ?? '-'} />
          <Field label="Nom" value={user?.name ?? '-'} />
          <div className="flex items-center gap-3">
            <span className="w-28 text-xs text-gray-400">Role</span>
            <Badge tone="brand">{user?.role ?? '-'}</Badge>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader title="Etat du systeme" />
        <CardContent className="space-y-2 text-sm">
          <Field label="Statut" value={healthData?.status ?? '-'} />
          <Field label="Version" value={healthData?.version ?? '-'} />
          <Field label="Redis" value={formatPingValue(healthData?.redis)} />
          <Field label="Postgres" value={formatPingValue(healthData?.db)} />
          <Field
            label="VMs up"
            value={
              healthData &&
              typeof healthData.vms_up_count === 'number' &&
              typeof healthData.vms_total_count === 'number'
                ? `${healthData.vms_up_count} / ${healthData.vms_total_count}`
                : '-'
            }
          />
          <Field
            label="Profondeur queue"
            value={typeof healthData?.queue_depth === 'number' ? String(healthData.queue_depth) : '-'}
          />
          <Field
            label="IMAP actifs"
            value={
              typeof healthData?.imap_active_count === 'number'
                ? String(healthData.imap_active_count)
                : '-'
            }
          />
          {health.isError && (
            <div className="pt-2 text-xs text-red-600">
              Le snapshot health n&apos;a pas pu etre charge.
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}

function formatPingValue(value: PingLike): string {
  if (!value) return '-';
  if (typeof value === 'string') return value;
  return value.ok ? 'up' : value.error ? `down - ${value.error}` : 'down';
}

function Field({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex items-center gap-3">
      <span className="w-28 text-xs text-gray-400">{label}</span>
      <span className="text-brand-dark">{value}</span>
    </div>
  );
}
